import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { FabricationNewJourneyModal } from '../../components/FabricationNewJourneyModal';
import useModalPriority, {
  _modalShownKey,
  ModalPriorities
} from '../../hooks/useModalPriority';
import { ERoutes } from '../../routes';
import { ApplicationState } from '../../store';
import FabricationOrders from './FabricationOrders';
import { LongSteelOrdersRoutes3 } from './LongSteelOrders3';
import SteelTypeChoose from './SteelTypeChoose';
import { GetFlag } from '../../utils/featureFlag';
import LongSteelOrders from './LongSteelOrders';
import { EUserPreferenceType } from '../../store/ducks/user/types';
import { LongSteelOrders3HomepageModal } from './LongSteelOrders3/LongSteelOrders3HomepageModal';

export enum EOrdersRoutes {
  STEEL_TYPE_CHOOSE = 'steel-type-choose',
  LONG_STEEL_ORDERS = 'long-steel',
  FABRICATION_ORDERS = 'fabrication' // corte e dobra
}

const OrdersRoutes: React.FC = () => {
  const path = `${ERoutes.ORDERS}`;
  const userState = useSelector((state: ApplicationState) => state.user);
  const hasUserFabricationAccess = useSelector(
    (appState: ApplicationState) =>
      appState.user.userPermissions.hasFabricationAccess
  );

  const isFabricationView =
    (userState.roles.fabricationViewCustomers || []).length > 0;

  const alreadyShownNewOrders = sessionStorage.getItem(
    _modalShownKey('modalFabricationNewJourney')
  );
  const [showFabricationNewJourney, modalFabricationNewJourneyActions] =
    useModalPriority(
      'modalFabricationNewJourney',
      ModalPriorities.FabricationNewJourney,
      isFabricationView,
      'new_jorney_fabrication'
    );

  const hasAccessToOrdersPage = userState.userPermissions.hasOrderViewAccess;

  const [showNewLongSteelOrdersModal, modalNewLongSteelOrdersActions] =
    useModalPriority(
      'modalNewLongSteelOrders',
      ModalPriorities.NewLongSteelOrders,
      !alreadyShownNewOrders && hasAccessToOrdersPage,
      'new_longsteelorders',
      true
    );

  const newLongSteelOrders = GetFlag('new_longsteelorders');

  const renderLongSteelOrders = () => {
    const newLongSteelPreferences =
      userState.preferences
        .find((item) => item.name === EUserPreferenceType.ORDER_VIEW)
        ?.toggles?.find((item) => item.value === 'newLongSteelOrdersView')
        ?.checked ?? true;

    if (newLongSteelOrders) {
      if (newLongSteelPreferences) {
        return LongSteelOrdersRoutes3;
      }

      return LongSteelOrders;
    }
    return LongSteelOrders;
  };

  return (
    <>
      {hasUserFabricationAccess && (
        <>
          <Route path={`${path}/`} exact>
            <Redirect to={`${path}/${EOrdersRoutes.STEEL_TYPE_CHOOSE}`} />
          </Route>

          <Route
            path={`${path}/${EOrdersRoutes.STEEL_TYPE_CHOOSE}`}
            component={SteelTypeChoose}
          />

          <Route
            path={`${path}/${EOrdersRoutes.FABRICATION_ORDERS}`}
            component={FabricationOrders}
          />
        </>
      )}

      {!hasUserFabricationAccess && (
        <>
          <Redirect to={`${path}`} />

          <Route path={`${path}/`} exact>
            <Redirect to={`${path}/${EOrdersRoutes.LONG_STEEL_ORDERS}`} />
          </Route>
        </>
      )}

      <Route
        path={`${path}/${EOrdersRoutes.LONG_STEEL_ORDERS}`}
        component={renderLongSteelOrders()}
      />
      {showNewLongSteelOrdersModal && (
        <LongSteelOrders3HomepageModal
          onCloseModal={modalNewLongSteelOrdersActions.close}
          dontShowThisAgain={modalNewLongSteelOrdersActions.dontShowThisAgain}
        />
      )}
      {showFabricationNewJourney && (
        <FabricationNewJourneyModal
          onCloseModal={modalFabricationNewJourneyActions.close}
          dontShowThisAgain={
            modalFabricationNewJourneyActions.dontShowThisAgain
          }
        />
      )}
    </>
  );
};

export default OrdersRoutes;
